import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, TextField, Typography } from '@mui/material';
import * as E from 'fp-ts/Either';
import { useEffect, useReducer } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import StageLayout from '../stage-layout';
import TwitterButton from '../twitter-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TwitterInput = function TwitterInput(_ref) {
  var tweet = _ref.tweet,
      error = _ref.error,
      requiredContent = _ref.requiredContent,
      handleChange = _ref.handleChange;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "TwitterInput",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [requiredContent ? /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          sx: {
            mt: 0.5
          },
          children: t('Make sure to include {{requiredContent}} in your tweet', {
            requiredContent: requiredContent
          })
        }) : null, /*#__PURE__*/_jsx(Box, {
          sx: {
            mt: 2
          },
          children: /*#__PURE__*/_jsx(TextField, {
            inputProps: {
              maxLength: 280
            },
            value: tweet,
            error: error,
            label: "Tweet",
            variant: "outlined",
            size: "small",
            sx: {
              width: '80%'
            },
            helperText: error ? t('You must include {{requiredContent}} in your tweet', {
              requiredContent: requiredContent !== null && requiredContent !== void 0 ? requiredContent : ''
            }) : t('{{tweetLength}} character(s)', {
              tweetLength: tweet.length
            }),
            onChange: function onChange(e) {
              return handleChange(e.target.value);
            }
          })
        })]
      });
    }
  });
};
export var tweetIncludesContent = function tweetIncludesContent(tweet, requiredContent) {
  return tweet.includes(" ".concat(requiredContent, " ")) || tweet.endsWith(" ".concat(requiredContent)) || tweet.startsWith("".concat(requiredContent, " "));
};

var twitterPostReducer = function twitterPostReducer(state, action) {
  switch (action.type) {
    case 'tweet':
      return _objectSpread(_objectSpread({}, state), {}, {
        tweet: action.tweet
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error
      });

    default:
      return state;
  }
};

var TwitterPost = function TwitterPost(_ref2) {
  var _twitterAccount$authU;

  var stage = _ref2.stage,
      activity = _ref2.activity,
      completeStage = _ref2.completeStage,
      twitterAccount = _ref2.twitterAccount,
      completeStageStatus = _ref2.completeStageStatus,
      isPreview = _ref2.isPreview,
      prospect = _ref2.prospect;
  var completionText = stage.completionText,
      defaultText = stage.defaultText,
      requiredContent = stage.requiredContent;

  var _useReducer = useReducer(twitterPostReducer, {
    tweet: defaultText !== null && defaultText !== void 0 ? defaultText : '',
    error: false
  }),
      _useReducer$ = _useReducer[0],
      tweet = _useReducer$.tweet,
      error = _useReducer$.error,
      dispatch = _useReducer[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref3) {
    var completeStage = _ref3.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  useEffect(function () {
    var _stage$defaultText;

    return dispatch({
      type: 'tweet',
      tweet: (_stage$defaultText = stage.defaultText) !== null && _stage$defaultText !== void 0 ? _stage$defaultText : ''
    });
  }, [stage.id]);
  return /*#__PURE__*/_jsxs(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(_Fragment, {
      children: twitterAccount && /*#__PURE__*/_jsx(TwitterButton, {
        connected: twitterAccount.connected,
        authUrl: (_twitterAccount$authU = twitterAccount === null || twitterAccount === void 0 ? void 0 : twitterAccount.authUrl) !== null && _twitterAccount$authU !== void 0 ? _twitterAccount$authU : '',
        status: mutationValue,
        defaultText: completionText || t('Share on Twitter'),
        savingText: t('Posting...'),
        completedText: t('Posted'),
        onClick: function onClick() {
          return !requiredContent || tweetIncludesContent(tweet, requiredContent) ? completeStage({
            twitterPostInput: {
              stageID: stage.id,
              activityID: activity === null || activity === void 0 ? void 0 : activity.id,
              tweet: tweet
            }
          }) : dispatch({
            type: 'error',
            error: true
          });
        },
        isPreview: isPreview
      })
    }),
    "data-element": "StageLayout",
    "data-component": "TwitterPost",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      "data-element": "Typography",
      "data-component": "TwitterPost",
      "data-source-file": "index.tsx",
      children: t('Edit your tweet')
    }), /*#__PURE__*/_jsx(TwitterInput, {
      tweet: tweet,
      error: error,
      requiredContent: requiredContent,
      handleChange: function handleChange(newValue) {
        dispatch({
          type: 'tweet',
          tweet: newValue
        });
        dispatch({
          type: 'error',
          error: false
        });
      },
      "data-element": "TwitterInput",
      "data-source-file": "index.tsx"
    })]
  });
};

export default TwitterPost;